import { observer } from 'mobx-react-lite'
import { TableRow as MuiTableRow } from '@mui/material'
import { PinnedCell } from 'shared/ui/TableNew/ui/PinnedCell/PinnedCell'
import { type IRowDefault } from 'shared/ui/TableNew'
import { LoadMoreExpandedRow } from './ui/LoadMoreExpandedRow/LoadMoreExpandedRow'

export type ITableRowChildProps<TRow extends IRowDefault> = {
  row: TRow
  isScrollLeft?: boolean
}

export const TableRowMore = observer(
  <TRow extends IRowDefault>({ row, ...props }: ITableRowChildProps<TRow>) => {
    const isScrollLeft = props.isScrollLeft || false

    return (
      <MuiTableRow>
        <PinnedCell isScrollLeft={isScrollLeft}>
          <LoadMoreExpandedRow row={row} />
        </PinnedCell>
      </MuiTableRow>
    )
  }
)
